define.alias("shared/components/shared/social/facebook-page", "media/components/shared/social/facebook-page");